// @flow

import React from 'react';
import styled from 'styled-components';

import Link from '../../../Link';
import SVG from './assets/logo_business.svg';

const Wrapper = styled.div``;

const Logo = () => (
  <Wrapper>
    <Link to="/">
      <img src={SVG} width="160" height="39" alt="999 Business" />
    </Link>
  </Wrapper>
);

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Header/partials/Logo/index.js